import { Component, Input } from "@angular/core";
import { PageDatagridColumnComponent } from "./page-datagrid-column.component";
import { PlatformType } from "src/app/common/platform-type";

@Component({
  selector: "pms-pagedatagrid-column-icon",
  template: "",
  providers: [
    {
      provide: PageDatagridColumnComponent,
      useExisting: PageDatagridColumnIconComponent
    }
  ],
  standalone: false
})
export class PageDatagridColumnIconComponent {
  @Input()
  name: string = "";

  @Input()
  dataField: string | undefined;

  @Input()
  title: string = "";

  @Input()
  icon: ((row: any) => string) | null = null;

  @Input()
  hidingPriority: number | undefined = undefined;

  @Input()
  hideOnViewport: string | undefined;

  @Input()
  hideOnPlatforms: PlatformType[] | undefined;

  @Input()
  tooltip: ((row: any) => string) | null = null;
}
